import React, { useState, useRef,useContext } from 'react';
import { Link } from 'react-router-dom';
import ProfilePic from "../Layout/ProfilePic";
import axios from 'axios';
import { GlobalContext } from '../../Context/GlobalContext';
import {getQueryVariable} from '../../Helpers/QueryString'
import './Header.css';

const Header = ({
  url,
  pub_user,
  unlisted,
  setVisible,
  menu,
  setMenu,
  user,
  setVideos,
  color,
  title,
  home,
}) => {

  const [isLoading, setIsLoading] = useState(false);
  const searchInputRef = useRef();
  const {thumbnailSize, setThumbnailSize, darkMode} = useContext(GlobalContext);
  const searchForVideo = async () => {
    setIsLoading(!isLoading);
    const searchTerm = searchInputRef.current.value;
    if (searchTerm === "") return setVideos([], false, searchTerm);
    try {
      const res = await axios.post( "https://8o1rav21mb.execute-api.us-west-2.amazonaws.com/production/search-videos", {
        userId: user,
        search: searchTerm
      })
      setVideos(res.data.files, true, searchTerm);
    }catch(error) {
      console.error("Error searching for videos:")
      console.error(error)
    }    
    
    setIsLoading(!isLoading)
  }

  // toggles side menu visibility when the hamburger menu is clicked 
  const displaySideMenu = () =>{
    const sideMenu = document.getElementById('sideMenu');
    if(sideMenu.style.display === 'none'){
      sideMenu.style.display = 'block';
      return;
    }
    sideMenu.style.display = 'none'
  }

  return (
    <>
      {/* Header */}
      <div 
        className={darkMode?'dark menu flex-row':'menu flex-row'} 
        style={{ 
          alignItems: "center", 
          paddingLeft: '1rem', 
          paddingRight: '1rem' 
        }}> 

        {/* Mobile Hamburger menu */}
        <div className="hamburger" onClick={displaySideMenu}>
            <div className="bar" style={{ cursor: "pointer", background: color }}></div>
            <div className="bar" style={{ cursor: "pointer", background: color }}></div>
            <div className="bar" style={{ cursor: "pointer", background: color }}></div>
        </div>

        {/* VOD channel name */}
        <div style={{ cursor: "pointer", color: color }} onClick={home}>
          {title}
        </div>

        {!unlisted && (
            <>
              {/* Searchbar container  */}
              <div className="search ml-3">
                <div className="input-group ml-3  mr-3 flex ">
                  <input
                  
                    type="search"
                    ref={searchInputRef}
                    autoComplete="off"
                    name={`${new Date().getTime()}${Math.random().toFixed(10)}`}
                    id={`${new Date().getTime()}${Math.random().toFixed(10)}`}
                    className="form-control"
                    placeholder="Search"
                    disabled={isLoading}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        searchForVideo();
                      }
                    }}
                  />

                  <div className="input-group-append">
                    <button className="btn input-group-text" onClick={searchForVideo}>
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
                
              {/* Profile pic container */}
          
              <div className="flex-1 flex-row" style={{ justifyContent: "flex-end" }}>
                <span className="thumb-dropdown" style={{display:'flex', marginRight: '0.5rem' }}>
                <span className='thumb-hover-text'>Thumbnail Sizes</span>
                <select 
                  className="thumb-dropdown"
                  value={thumbnailSize} 
                  onChange={e=>setThumbnailSize(e.target.value)} 
                  defaultValue={"medium"}
                >
                    <option className='thumb-dropdown-opt' value="small" >Small&nbsp;&nbsp;&nbsp;&nbsp;</option>
                    <option className='thumb-dropdown-opt' value="medium">Medium&nbsp;&nbsp;&nbsp;&nbsp;</option>
                    <option className='thumb-dropdown-opt' value="large">Large&nbsp;&nbsp;&nbsp;&nbsp;</option>
                  </select>
                </span>
                {!pub_user._id &&
                  <button className="btn btn-outline-primary" onClick={() => setVisible(true)}>
                    Sign In
                  </button>
                }
                
                {pub_user._id && 
                  <div onClick={() => setMenu(!menu)}>
                    <ProfilePic user={pub_user} />
                  </div>
                }
              </div>
            </>
          )
        }
      </div>
    </>
  )
}

export default Header